:host {
    display: block;

    img {
        width: 100%;
        display: block;

        &.object-fit {
            height: 100%;
            object-fit: cover;
        }

        &.object-fit-contain {
            height: 100%;
            object-fit: contain;
        }
    }
}

// set cursor for sew-ws-image-zoom
@include mq-2-min {
    :host([slot='preview']) {
        img {
            cursor: pointer;
        }
    }
}

.caption {
    @include typo-ws-paragraph-fixed;

    color: $color-grey-02-steel;
    padding: 8px 0 0;
    margin: 0;

    &.shift-caption-right {
        padding: 8px 0 0 var(--grid-margin);
    }
}

@include mq-4-min {
    .caption {
        &.shift-caption-right {
            padding-left: 0;
        }
    }
}

@include mq-3-only {
    .caption {
        &.shift-caption-right-mq3 {
            padding: 8px 0 0 var(--grid-margin);
        }
    }
}

@include mq-1 {
    .caption {
        &.shift-caption-right {
            padding-left: 0;
        }
    }
}
